/**
 * Client-side mirror of backend/src/game/economy/config/economy-tuning.ts's
 * display-relevant constants — same hand-synced convention as
 * config/character-roster.ts and config/item-defs.ts. Used only to preview
 * prices/costs in the UI before a request; the server recomputes and is
 * authoritative on every actual transaction.
 */
export const ECONOMY = {
  SELL_PRICE_FRACTION: 0.5,
  EXCHANGE_RATE: 10,
  DAILY_EXCHANGE_CAP_PREMIUM: 300,
  INITIAL_STASH_CAPACITY: 25,
  STASH_EXPANSION_INCREMENT: 10,
  BASE_EXPAND_COST: 100,
  COST_PER_SLOT_INCREMENT: 15,
} as const;
